import { render, staticRenderFns } from "./purchase-records.vue?vue&type=template&id=bb7a13c2&"
import script from "./purchase-records.vue?vue&type=script&lang=js&"
export * from "./purchase-records.vue?vue&type=script&lang=js&"
import style0 from "./purchase-records.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports